export default __webpack_public_path__ + "static/media/61r7mF8Vs5L._AC_UF1000,1000_QL80_.7f416561.webp";